import { Injectable } from '@angular/core';
import { ObservableInput } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiLanguageService } from '../core/multi-language/multi-language.service';
import { AppBaseService } from './http.service';
import { NgxImageCompressService } from 'ngx-image-compress';


@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  formData: FormData = new FormData();
  appointmentNo: any;
  _onDestroy: ObservableInput<any>;
  docTypeCode: any;
  folderCode: any;
  fileDescription: any;
  files: any;

  constructor(private langService: MultiLanguageService,
    public appBaseService: AppBaseService,
    public snackBar: MatSnackBar,
    private imageCompress: NgxImageCompressService) {
   }

   getFileUpload(list, mrn, visitNo, typeCode, folderCode, identificationNo?) {
    list.forEach((element) => {
      if (!element.files || element.files.length === 0) return;
    
      // Convert FileList to an array
      const fileArray: File[] = Array.from(element.files);
      const isAllImages = fileArray.every(file => file.type.startsWith('image/'));
  
      if (isAllImages) {
      let compressedImages: File[] = [];
      // Process all files asynchronously
      const compressionPromises = fileArray.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
  
          reader.readAsArrayBuffer(file);
          reader.onload = () => {
            const arrayBuffer = reader.result as ArrayBuffer;
  
            // Convert ArrayBuffer to Base64
            const base64String = this.arrayBufferToBase64(arrayBuffer);
            const imageDataUrl = `data:${file.type};base64,${base64String}`;
  
            console.log(`Converted Base64 for ${file.name}:`, imageDataUrl);
  
            console.log(`Original Size of ${file.name}: ${Math.round(file.size / 1024)} KB`);
  
            // Compress image (reduce by 50%, quality 50)
            console.log("Compressing file:", file.name);
            this.imageCompress.compressFile(imageDataUrl, -1, 30, 30)
              .then((compressedData) => {
                const compressedSize = Math.round((compressedData.length * 3) / 4 / 1024); // Base64 increases size by ~33%
  
                console.log(`Compressed Size of ${file.name}: ${compressedSize} KB`);
  
                // Convert compressed base64 back to a Blob file
                const blob = this.base64ToBlob(compressedData, file.type);
                const compressedFile = new File([blob], file.name, { type: file.type });
  
                compressedImages.push(compressedFile);
                resolve(compressedFile);
              })
              .catch((error) => {
                console.error(`Compression failed for ${file.name}:`, error);
                reject(error);
              });
          };
  
          reader.onerror = (error) => {
            console.error(`Error reading file ${file.name}:`, error);
            reject(error);
          };
        });
      });
  
      // Wait for all files to be compressed before uploading
      Promise.all(compressionPromises).then((compressedFiles) => {
        if (compressedFiles.length) {
          this.formData = new FormData();
          this.formData.append("mrn", mrn ? mrn : "");
          this.formData.append("docTypeCode", element.doctype ? element.doctype : "");
          this.formData.append("fileDescription", element.fileDescription ? element.fileDescription : "");
          this.formData.append("folderCode", folderCode ? folderCode : "");
          this.formData.append("visitNo", visitNo ? visitNo : "");
          this.formData.append("identificationNo", identificationNo ? identificationNo : "");
          this.formData.append("documentStatusCode", element.docFileType ? element.docFileType : (element.fileType ? element.fileType : 'final'));
          this.formData.append("screenCode", element.screenCode ? element.screenCode : '');
  
          compressedFiles.forEach((compressedFile:any) => {
            this.formData.append("files", compressedFile);
          });
  
          let apiurl = "file/uploadMultipleFiles";
          this.appBaseService.setResourceURL("/doc-service/");
          this.appBaseService.postResource(apiurl, this.formData).subscribe(() => {
            this.snackBar.open(
              this.langService.get("EncounterPage.fileUploadSuccess"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 1000,
              }
            );
          });
        }
      });
    }
    else {
      this.formData = new FormData();
      this.formData.append("mrn", mrn ?? "");
      this.formData.append("docTypeCode", element.doctype ?? "");
      this.formData.append("fileDescription", element.fileDescription ?? "");
      this.formData.append("folderCode", folderCode ?? "");
      this.formData.append("visitNo", visitNo ?? "");
      this.formData.append("identificationNo", identificationNo ?? "");
      this.formData.append("documentStatusCode", element.docFileType ?? element.fileType ?? 'final');
      this.formData.append("screenCode", element.screenCode ?? "");

      fileArray.forEach(file => {
        this.formData.append("files", file);
      });

      const apiurl = "file/uploadMultipleFiles";
      this.appBaseService.setResourceURL("/doc-service/");
      this.appBaseService.postResource(apiurl, this.formData).subscribe(() => {
        this.snackBar.open(
          this.langService.get("EncounterPage.fileUploadSuccess"),
          this.langService.get("CommonAppoinment.success"),
          { duration: 1000 }
        );
      });
    }
    });
  }

  compressBase64Image(base64Str: string, quality: number = 0.6): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64Str;
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
  
        const MAX_WIDTH = 800; // You can resize image here
        const scale = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;
  
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Canvas context not available');
  
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
        // Compress to JPEG
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
  
        const originalSizeKB = (base64Str.length * 3) / 4 / 1024;
        const compressedSizeKB = (compressedBase64.length * 3) / 4 / 1024;
  
        console.log('Original Size:', originalSizeKB.toFixed(2), 'KB');
        console.log('Compressed Size:', compressedSizeKB.toFixed(2), 'KB');
  
        resolve(compressedBase64);
      };
  
      img.onerror = (err) => reject(err);
    });
  }
  
  /**
   * Converts an ArrayBuffer to a Base64 string
   */
  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }
  
  /**
   * Converts a Base64 string to a Blob
   */
  base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64.split(",")[1]); // Remove data URL prefix
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }
    return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
  }
  
  
}
